import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";
import { getUserSession } from "../../../util/core/Session";
import { useState, useEffect } from "react";
import sleep from "sleep-promise";

function Form() {

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const session = getUserSession();

    const pathFrontEnd = '/core/attempts/';
    const pathBackEnd = 'core/configs/';
    const paths = {
        endpointSave: config.endpoints.backend + pathBackEnd + 'save',
        endpointGetByReference:
            config.endpoints.backend + pathBackEnd + 'getByReference',
        urlGoBack: '',
        pathView: pathFrontEnd + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Configuração",
        labelTitleEdit: "Editar Configuração",
        labelTitleView: 'Visualizar Configuração'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            showGoBackButton: false,
            hiddenValues: {
                core_application_instance_id: session.user.application_instance_id,
                reference: 'config-access-attempts'
            },
            fields: [
                {
                    name: "amount_attempts",
                    type: "integer",
                    label: "Número de tentativas",
                    validations: {
                        required: false,
                    },
                    columnSize: 12,
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            try {
                const response = await Fetch.post(paths.endpointGetByReference, {
                    core_application_instance_id: session.user.application_instance_id,
                    reference: 'config-access-attempts'
                });

                values = response.config || {};

            } catch (error) {
                console.error("Erro durante a execução da função load:", error);
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;